import { useState } from 'react';
import { Box, Button, Card, CardActionArea, CardContent, CardMedia, Grid, TextField, Typography } from '@mui/material';
import { Category, Device } from '../../Utils/types';
import { Vocabulary } from '../../Utils/Vocabulary';

interface Props {
  devices: Device[];
  category: Category;
  onSelect: (device: Device) => void;
  onBack: () => void;
}

export default function StepDevice({ devices, category, onSelect, onBack }: Props) {
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState<Device | null>(null);

  const filtered = devices
    .filter((d) => d.category === category._id)
    .filter((d) => d.deviceName.toLowerCase().includes(search.toLowerCase()));

  function handleContinue() {
    if (selected) onSelect(selected);
  }

  return (
    <Box>
      <Typography variant="h5" sx={{ textAlign: 'center' }} gutterBottom>
        {Vocabulary.stepDevice}
      </Typography>
      <Typography variant="subtitle1"  sx={{ textAlign: 'center' }} color="text.secondary" gutterBottom>
        {Vocabulary.stepDeviceSubtitle}
      </Typography>
 
 <Box display="flex" justifyContent="space-between" mt={4} sx={{ mb: 3 }}>
        <Button variant="outlined" onClick={onBack}>{Vocabulary.back}</Button>
        <Button variant="contained" onClick={handleContinue} disabled={!selected}>
          {Vocabulary.continue}
        </Button>
      </Box>

      <TextField
        inputProps={{ placeholder: Vocabulary.searchDevice }}
        fullWidth
        size="small"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 3 }}
      />

      {filtered.length === 0 && (
        <Typography color="text.secondary">{Vocabulary.noDevicesFound}</Typography>
      )}


      <Grid container spacing={2}>
        {filtered.map((device) => {
          const imgSrc = device.images?.[0] || undefined;
          const isSelected = selected?._id === device._id;
          return (
            <Grid item xs={12} sm={4} lg={2} md={4} key={device._id}>
              <Card
                elevation={isSelected ? 6 : 2}
                sx={{
                  borderRadius: 2,
                  border: '2px solid',
                  borderColor: isSelected ? 'primary.main' : 'transparent',
                  height: '250px',
                }}
              >
                <CardActionArea onClick={() => setSelected(device)}>
                  {imgSrc && (
                    <CardMedia component="img" height="160" image={imgSrc} alt={device.deviceName} sx={{ objectFit: 'contain', p: 1 }} />
                  )}
                  <CardContent>
                    <Typography variant="body1" align="center">{device.deviceName}</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Box display="flex" justifyContent="space-between" mt={4}>
        <Button variant="outlined" onClick={onBack}>{Vocabulary.back}</Button>
        <Button variant="contained" onClick={handleContinue} disabled={!selected}>
          {Vocabulary.continue}
        </Button>
      </Box>
    </Box>
  );
}
